import type { AbstractControl } from '@angular/forms';
import { PctFormGroup } from './pct-form-group';
import { isNil, isObject, isString } from '@pct-ts/typeguard';
import { type FormState, formStates } from './form-state';

export interface WithForm<CONTROL extends { [K in keyof CONTROL]: AbstractControl } = any> {
  readonly form: PctFormGroup<CONTROL>;
}

export function isWithForm(obj: unknown): obj is WithForm {
  return isObject(obj) && !isNil(obj) && 'form' in obj && obj.form instanceof PctFormGroup;
}

export interface WithFormState {
  formState: FormState;
}

export function isWithFormState(obj: unknown): obj is WithFormState {
  return (
    isObject(obj) &&
    !isNil(obj) &&
    'formState' in obj &&
    isString(obj['formState']) &&
    formStates.some(state => state === obj['formState'])
  );
}
